// Credits for community maps the player opened on GameBanana, kept in this browser so a map shows
// who made it once its file is loaded (matched by map / file name).

const KEY = 'bhop-web-map-credits';

export interface MapCredit {
  name: string;
  authors: string[];
  url: string;
}

const norm = (s: string) =>
  s
    .toLowerCase()
    .replace(/\.(bsp|zip|rar|7z|bz2)$/g, '')
    .replace(/\.(bsp|zip|rar|7z|bz2)$/g, '')
    .trim();

function load(): Record<string, MapCredit> {
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? '{}') as Record<string, MapCredit>;
  } catch {
    return {};
  }
}

/** Remember a map's credit under its name and its file names. */
export function rememberCredit(credit: MapCredit, fileNames: string[] = []) {
  const all = load();
  for (const n of [credit.name, ...fileNames]) all[norm(n)] = credit;
  try {
    localStorage.setItem(KEY, JSON.stringify(all));
  } catch {
    // Not kept; the credit just won't show in game.
  }
}

/** The credit for a loaded map, by its map name or the file it came from. */
export function creditFor(...names: string[]): MapCredit | null {
  const all = load();
  for (const n of names) {
    if (!n) continue;
    const k = norm(n);
    if (all[k]) return all[k];
    // "bhop_eazy_v2" played from the "bhop_eazy" page, or the other way round.
    const hit = Object.keys(all).find((c) => c.length > 4 && (k.startsWith(c) || c.startsWith(k)));
    if (hit) return all[hit];
  }
  return null;
}
